import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useContext, useState } from "react";
import TenantContext from "../../context/tenant/TenantContext";
import { toast } from "../../helper/common";
import axiosInstance from "../../services/authWrapper";
import UserIcon from "../../assets/img/user-icon.svg";
import DeleteConfirationForDoc from "../TenantDetails/DeleteConfirmationForDoc";

const DuplicateDocModal = (props) => {
  const [deleteDocumentConfirmation, setDeleteDocumentConfirmation] =
    useState(false);
  const [selectedDocument, setselectedDocument] = useState({
    userName: null,
    doc: null,
  });
  const [deleteDocumentLoading, setDeleteDocumentLoading] = useState(false);
  const { _t } = useTranslator();
  const {
    showDuplicateModal,
    setShowDuplicateModal,
    duplicateDocsByProfile,
    setDuplicateDocsByProfile,
  } = props;

  const { deleteDuplicateDocuments, skipDuplicateDocument } =
    useContext(TenantContext);

  const tempFunc = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_SERVER_URL}/tenants/risk/analyser`, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDeleteDuplicate = (userName, docToDelete) => {
    console.log(docToDelete, "checkthis");
    const sendData = {
      owner: userName,
      documentName: docToDelete?.name,
    };
    setDeleteDocumentLoading(true);
    deleteDuplicateDocuments(sendData)
      .then((res) => {
        toast.success(_t("duplicateDocDeletedSuccessfully"));
        setDuplicateDocsByProfile((prev) => {
          const updated = { ...prev };

          // 🔹 Filter out the clicked doc
          const filteredDocs = updated[userName].filter(
            (doc) => doc.name !== docToDelete.name,
          );

          // 🔹 If no docs left, remove user entirely
          if (filteredDocs.length === 0) {
            delete updated[userName];
          } else {
            updated[userName] = filteredDocs;
          }

          return updated;
        });
      })
      .catch((err) => {
        toast.error(_t("errorWhileDeletingDuplicateDoc"));
      })
      .finally(() => {
        setDeleteDocumentLoading(false);
        setDeleteDocumentConfirmation(false);
      });
  };

  const handleContinue = () => {
    skipDuplicateDocument();
    setShowDuplicateModal(false);
  };
  return (
    <>
      {!deleteDocumentConfirmation && (
        <Modal
          show={showDuplicateModal}
          onHide={(e) => handleContinue()}
          centered
          className="newmodalui wrapper-modal inviteTenantModal duplicate-documents-modal max-w-lg awardPropertyModal text-center"
        >
          <Modal.Header>
            <h4>{_t("duplicateDocuments")}</h4>
            <p>{_t("belowAreDocumentsUploadedByYou")}</p>
            <div className="cursor-pointer" onClick={() => handleContinue()}>
              <img
                src={Cancelimg}
                alt="icon"
                className="canceicon topRightIcon"
              />
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="duplicate-document-modal-info">
              {Object.entries(duplicateDocsByProfile).map(
                ([userName, docs]) => (
                  <div key={userName} className="document-card">
                    {/* 🔹 User Name */}
                    <h5>
                      <div className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
                        <img src={UserIcon} alt="User Icon" />
                      </div>
                      {userName}
                    </h5>

                    {/* 🔹 Duplicate Documents */}
                    <div className="d-flex flex-column justify-content-between align-items-center">
                      {docs.map((doc, index) => (
                        <div key={index} className="user-documentName">
                          <div className="d-flex align-items-center">
                            <img src={"/images/docIconGreen.svg"} alt="logo" />
                            <span>{doc.name}</span>
                          </div>
                          <img
                            src="/images/delete-icon.svg"
                            className="deleteIcon cursor-pointer"
                            onClick={() => {
                              setDeleteDocumentConfirmation(true);
                              setselectedDocument({
                                userName: userName,
                                doc: doc,
                              });
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ),
              )}
            </div>
          </Modal.Body>
          <div className="inviteButtonWrapper">
            <button
              type="button"
              className="btnNext basicInfoButton duplicate-document-footer-button greenHover"
              onClick={handleContinue}
            >
              {_t("keepAndContinue")}
            </button>
          </div>
        </Modal>
      )}

      <DeleteConfirationForDoc
        isOpen={deleteDocumentConfirmation}
        onClose={() => setDeleteDocumentConfirmation(false)}
        name={selectedDocument?.doc?.name ?? ""}
        heading={_t("deleteDocument")}
        description={_t("areYouSureYouWantToDeleteThisDuplicateDocument")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setDeleteDocumentConfirmation(false)}
        btn2Functionality={() =>
          handleDeleteDuplicate(selectedDocument.userName, selectedDocument.doc)
        }
        submitLoading={deleteDocumentLoading}
      />
    </>
  );
};

export default DuplicateDocModal;
